module.exports = __webpack_public_path__ + "static/media/US.08c19aab.png";